/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import Text from 'src/components/ts-components/Text'

interface SectionHeaderProps {
  title: string
  onViewAll?: () => void
}

const SectionHeader = ({ title, onViewAll }: SectionHeaderProps) => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <Text variant='heading5' weight='semiBold' color={colors.NEUTRAL_0}>
        {title}
      </Text>
      {onViewAll && (
        <button
          onClick={onViewAll}
          css={css`
            border: 1px solid ${colors.PRIMARY};
            border-radius: 8px;
            padding: 4px 12px;
            background: transparent;
            font-family: 'Inter', sans-serif;
            font-weight: 500;
            font-size: 14px;
            color: ${colors.PRIMARY};
            cursor: pointer;
            transition: opacity 0.15s ease;

            &:hover {
              opacity: 0.8;
            }
          `}
        >
          View All
        </button>
      )}
    </div>
  )
}

export default SectionHeader
